import { Button, Input } from 'reactstrap';
import DateTypedInput from 'components/form-components/date-typed-input.component';
import SimpleSelect from '../../../../components/form-components/simple-select.component';
import { TextLogic } from '../../logic/text.logic';
import TimeInput from '../../../../components/form-components/time-input.component';
import { ReactComponent as ChatIcon } from '../../../../images/bubble-text.svg';
import { ReactComponent as DeleteIcon } from '../../../../images/delete.svg';
import React from 'react';
import { ITimesheetEditEntryState } from './timesheet-edit-entry.component';
import { ShiftType } from '@ms/timesheets/dist/models/shift-type';
import classNames from 'classnames';
import { MedSolTippy } from '@ms/medsol-components';

const renderDesktop = ({
    handleChangeDate,
    inputClass,
    selectedTimesheet,
    shiftTypes,
    timeEntry,
    updateEntry,
    updatedTimeEntry,
    entryKey,
    showAddDelete,
    deleteMsg,
    totalHours,
    isTimeEntryChanged,
    timeInValid,
    timeOutValid,
    lunchInValid,
    lunchOutValid,
    showCostCenters,
    costCenters,
}: ITimesheetEditEntryState): JSX.Element => {
    if (!updatedTimeEntry.isActive && showAddDelete) {
        return (
            <tr className={'pay-cycle-separator'}>
                <td colSpan={10} className={'border-top border-bottom'}>
                    {deleteMsg}
                    <Button color="link" size="sm" onClick={() => updateEntry('isActive', true)}>
                        Undo
                    </Button>
                </td>
            </tr>
        );
    }

    return (
        <tr className="form-control--transparent">
            <td>
                <label className="sr-only" htmlFor={`entryDate-${timeEntry.id}`}>
                    Date
                </label>
                <DateTypedInput
                    disabled={!!selectedTimesheet.onlineApprovalDate}
                    className={inputClass('entryDate')}
                    id={`entryDate-${timeEntry.id}`}
                    name="entryDate"
                    onChange={handleChangeDate}
                    value={updatedTimeEntry?.entryDate}
                />
            </td>
            <td>
                <label className="sr-only" htmlFor={`shiftType-${timeEntry.id}`}>
                    Shift Type
                </label>
                <SimpleSelect
                    disabled={!!selectedTimesheet.onlineApprovalDate}
                    className={inputClass('shiftType')}
                    id={`shiftType-${timeEntry.id}`}
                    name="shiftType"
                    onChange={(e: string) => updateEntry('shiftType', e)}
                    options={shiftTypes}
                    value={TextLogic.spaceOutCapitalization(ShiftType[updatedTimeEntry?.shiftType])}
                />
            </td>
            <td>
                <label className="sr-only" htmlFor={`timein-${timeEntry.id}`}>
                    Time In
                </label>
                <TimeInput
                    disabled={!!selectedTimesheet.onlineApprovalDate}
                    className={inputClass('timeIn')}
                    id={`timein-${timeEntry.id}`}
                    name={'timeIn' + entryKey}
                    onChange={(e: string) => updateEntry('timeIn', e)}
                    value={updatedTimeEntry?.timeIn}
                    isValid={timeInValid}
                />
            </td>
            <td>
                <label className="sr-only" htmlFor={`lunchOut-${timeEntry.id}`}>
                    Lunch Out
                </label>
                <TimeInput
                    disabled={!!selectedTimesheet.onlineApprovalDate}
                    className={inputClass('lunchOut')}
                    id={`lunchOut-${timeEntry.id}`}
                    name={'lunchOut' + entryKey}
                    onChange={(e: string) => updateEntry('lunchOut', e)}
                    value={updatedTimeEntry?.lunchOut}
                    isValid={lunchOutValid}
                />
            </td>
            <td>
                <label className="sr-only" htmlFor={`lunchIn-${timeEntry.id}`}>
                    Lunch In
                </label>
                <TimeInput
                    disabled={!!selectedTimesheet.onlineApprovalDate}
                    className={inputClass('lunchIn')}
                    id={`lunchIn-${timeEntry.id}`}
                    name={'lunchIn' + entryKey}
                    onChange={(e: string) => updateEntry('lunchIn', e)}
                    value={updatedTimeEntry?.lunchIn}
                    isValid={lunchInValid}
                />
            </td>
            <td>
                <label className="sr-only" htmlFor={`timeOut-${timeEntry.id}`}>
                    Time Out
                </label>
                <TimeInput
                    disabled={!!selectedTimesheet.onlineApprovalDate}
                    className={inputClass('timeOut')}
                    id={`timeOut-${timeEntry.id}`}
                    name={'timeOut' + entryKey}
                    onChange={(e: string) => updateEntry('timeOut', e)}
                    value={updatedTimeEntry?.timeOut}
                    isValid={timeOutValid}
                />
            </td>
            {showCostCenters && (
                <td>
                    <label className="sr-only" htmlFor={`costcenter-${timeEntry.id}`}>
                        Cost Center
                    </label>
                    <SimpleSelect
                        data-testid={`costCenter-${timeEntry.id}`}
                        disabled={!!selectedTimesheet.onlineApprovalDate}
                        className={inputClass('costCenterId')}
                        id={`costCenterId-${timeEntry.id}`}
                        name={'costCenterId' + entryKey}
                        onChange={(e: string) => updateEntry('costCenterId', e)}
                        options={costCenters}
                        value={updatedTimeEntry?.costCenterId}
                    />
                </td>
            )}
            <td>
                <Input
                    disabled
                    bsSize="sm"
                    value={totalHours}
                    className={classNames([
                        isTimeEntryChanged ? 'font-weight-semibold primary' : 'font-weight-normal text-muted',
                        { 'text-red': totalHours === 'Invalid' },
                    ])}
                />
            </td>
            <td>
                {timeEntry.comment && (
                    <MedSolTippy label={`Traveler comments${timeEntry.comment ? ': ' + timeEntry.comment : ''}`}>
                        <ChatIcon className="chat-icon" />
                    </MedSolTippy>
                )}
            </td>
            {showAddDelete && (
                <td>
                    <Button color="link" className="delete-button" onClick={() => updateEntry('isActive', false)}>
                        <DeleteIcon />
                        <span className="sr-only">Delete</span>
                    </Button>
                </td>
            )}
        </tr>
    );
};

export default renderDesktop;
